import { useEffect, useState } from 'react';
import './App.css';
import FullProfile from './components/fullprofile';
import axios from "axios"

function App() {
  const [allData, setData] = useState([]);
  const [info, setInfo] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedCharacter, setSelectedCharacter] = useState(null); // NEW

  const fetchData = async (page = 1) => {
    try {
      const res = await axios.get(`https://rickandmortyapi.com/api/character/?page=${page}`);
      setData(res.data.results);
      setInfo(res.data.info);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(pageNumber);
  }, [pageNumber]);

  // If a character is selected, show FullProfile
  if (selectedCharacter) {
    return (
      <div className='app'>
        <button className='back-btn' onClick={() => setSelectedCharacter(null)}>Back</button>
        <FullProfile character={selectedCharacter} />
      </div>
    );
  }

  return (
    <div className='app'>
      <h2 className='page_title'>Rick and Morty Characters</h2>
      <div className='container'>
        {allData.map((dt) => (
          <div
            className="profile"
            key={dt.id}
            onClick={() => setSelectedCharacter(dt)}
          >
            <img src={dt.image} alt={dt.name} />
            <h4><span style={{ color: "pink" }}>{dt.name}</span></h4>
            <h4 className='gender'><span style={{ color: "red" }}>{dt.gender}</span></h4>
            <span className='status'>{dt.status}</span>
          </div>
        ))}
      </div>
      <div className='pagination'>
        <div className='page-number'>Page {pageNumber} of {info.pages}</div>
        <button
          onClick={() => setPageNumber(pageNumber - 1)}
          disabled={pageNumber === 1}
        >
          Prev
        </button>
  
        <button
          onClick={() => setPageNumber(pageNumber + 1)}
          disabled={pageNumber === info.pages}
        >
          Next
        </button>
      </div>
      <div style={{padding: '2em', textAlign: 'center', color: 'white'}}>
        <h4>This is just a practice of how to work with APIs</h4>
      </div>
    </div>

    
  );
}

export default App;
